/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_7_P2Inputs */

const en_terms_section_7_p2 = /** @type {(inputs: Terms_Section_7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo is not responsible for what is on those sites, how they handle data, or whether they are available. Following such a link is at your own risk and under their terms.`)
};

const lv_terms_section_7_p2 = /** @type {(inputs: Terms_Section_7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo neatbild par šo vietņu saturu, datu apstrādi vai pieejamību. Šādas saites atvēršana notiek uz Jūsu paša atbildību un saskaņā ar attiecīgās vietnes noteikumiem.`)
};

/**
* | output |
* | --- |
* | "Lindevo is not responsible for what is on those sites, how they handle data, or whether they are available. Following such a link is at your own risk and und..." |
*
* @param {Terms_Section_7_P2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_7_p2 = /** @type {((inputs?: Terms_Section_7_P2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_7_P2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_7_p2(inputs)
	return en_terms_section_7_p2(inputs)
});